import { useTranslation } from "react-i18next";
import stepsStyles from "../steps.module.css";

export default function StepContacto({ formData, setFormData, errors = {} }) {
  const { t } = useTranslation();

  const TIPO_TEL_OPTS = [
    { value: "MOVIL",   label: t("proveedores.telTipoMovil") },
    { value: "TRABAJO", label: t("proveedores.telTipoTrabajo") },
    { value: "OFICINA", label: t("proveedores.telTipoOficina") },
    { value: "HOGAR",   label: t("proveedores.telTipoHogar") },
    { value: "FAX",     label: t("proveedores.telTipoFax") },
    { value: "OTRO",    label: t("proveedores.telTipoOtro") },
  ];

  function handleChange(field, value) {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }

  function addTel() {
    setFormData((prev) => ({
      ...prev,
      telefonos: [...prev.telefonos, { codigo_pais: "+506", numero: "", tipo: "MOVIL" }],
    }));
  }

  function removeTel(idx) {
    setFormData((prev) => ({
      ...prev,
      telefonos: prev.telefonos.filter((_, i) => i !== idx),
    }));
  }

  function updateTel(idx, key, val) {
    setFormData((prev) => ({
      ...prev,
      telefonos: prev.telefonos.map((tel, i) => (i === idx ? { ...tel, [key]: val } : tel)),
    }));
  }

  return (
    <div className="step">
      <h3 className="p-0 mt-2 mb-0 title" style={{ fontSize: "1.3rem" }}>
        {t("proveedores.contactoTitulo")}
      </h3>
      <p className={`${stepsStyles.inactive} mb-3`} style={{ fontSize: "1rem" }}>
        {t("proveedores.contactoSubtitulo")}
      </p>

      <div className={stepsStyles["form-wrapper"]}>
        {/* Email */}
        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            type="email"
            className={`${stepsStyles["form-control"]} form-control`}
            style={{ borderColor: errors.email ? "#ef4444" : undefined }}
            placeholder="correo@proveedor.com"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
          />
          {errors.email && (
            <p style={{ margin: "4px 0 0", fontSize: "0.75rem", color: "#f87171" }}>{errors.email}</p>
          )}
        </div>

        {/* Contacto de referencia */}
        <div className="form-group">
          <label className="form-label">{t("proveedores.contactoRef")}</label>
          <input
            type="text"
            className={`${stepsStyles["form-control"]} form-control`}
            placeholder={t("proveedores.contactoRefPlaceholder")}
            value={formData.contacto}
            onChange={(e) => handleChange("contacto", e.target.value)}
          />
          <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginTop: 3 }}>
            {t("proveedores.contactoHint")}
          </div>
        </div>

        {/* Teléfonos */}
        <div className="form-group">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <label className="form-label mb-0">{t("proveedores.telefonos")}</label>
            <button
              type="button"
              onClick={addTel}
              style={{
                background: "rgba(249,115,22,0.12)", border: "1px solid rgba(249,115,22,0.3)",
                color: "#f97316", borderRadius: 6, padding: "4px 12px",
                fontSize: "0.78rem", cursor: "pointer", fontWeight: 600,
              }}
            >
              <i className="fa-solid fa-plus" style={{ marginRight: 5 }} />{t("proveedores.agregarTelefono")}
            </button>
          </div>

          {formData.telefonos.length === 0 && (
            <p style={{
              color: "var(--text-muted)", fontSize: "0.8rem", textAlign: "center",
              padding: "14px 0", border: "1px dashed rgba(255,255,255,0.1)", borderRadius: 6,
            }}>
              {t("proveedores.sinTelefonos")}
            </p>
          )}

          {formData.telefonos.map((tel, i) => (
            <div key={i} style={{ display: "grid", gridTemplateColumns: "120px 100px 1fr 36px", gap: 6, marginBottom: 8 }}>
              <div>
                {i === 0 && <label className="form-label" style={{ fontSize: "0.7rem" }}>{t("common.tipo")}</label>}
                <select
                  value={tel.tipo}
                  onChange={(e) => updateTel(i, "tipo", e.target.value)}
                  className={`${stepsStyles["form-control"]} form-control`}
                >
                  {TIPO_TEL_OPTS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
              <div>
                {i === 0 && <label className="form-label" style={{ fontSize: "0.7rem" }}>{t("common.pais")}</label>}
                <input
                  type="text"
                  className={`${stepsStyles["form-control"]} form-control`}
                  value={tel.codigo_pais}
                  onChange={(e) => updateTel(i, "codigo_pais", e.target.value)}
                  placeholder="+506"
                />
              </div>
              <div>
                {i === 0 && <label className="form-label" style={{ fontSize: "0.7rem" }}>{t("common.numero")}</label>}
                <input
                  type="text"
                  className={`${stepsStyles["form-control"]} form-control`}
                  value={tel.numero}
                  onChange={(e) => updateTel(i, "numero", e.target.value)}
                  placeholder="8888-0000"
                />
              </div>
              <button
                type="button"
                onClick={() => removeTel(i)}
                style={{
                  background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.25)",
                  color: "#f87171", borderRadius: 6, width: 34, height: 34,
                  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                  alignSelf: i === 0 ? "flex-end" : "center",
                }}
              >
                <i className="fa-solid fa-trash" style={{ fontSize: "0.75rem" }} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
